import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { ConnectedRouter as Router } from "connected-react-router";
import { history } from "../redux";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { path } from "../utils";
import { CustomToastCloseButton } from "../components/CustomToast";
import ConfirmModal from "../components/ConfirmModal";
import "./App.scss";

import Home from "../containers/Client/Home/Home";
import ProductA5 from "../containers/Client/Product/A5/ProductA5";
import Contact from "../containers/Client/Contact/Contact";
import About from "../containers/Client/About/About";
import FAQ from "../containers/Client/FAQ/FAQ";
import PrivacyPolicy from "./Client/Privacy/PrivacyPolicy";
import RefundPolicy from "./Client/Privacy/RefundPolicy";
import ShippingPolicy from "./Client/Privacy/ShippingPolicy";
import Term from "./Client/Privacy/Term";
import FIBO from "./Client/Privacy/FIBO";
import Order from "./Client/Order/Order";
import ScrollToTop from "./Client/inc/ScrollToTop";
import Post from "./Client/Post/Post";
import ProductWarranty from "./Client/Privacy/ProductWarranty";
// import Trial from "./Client/Trial/Trial";
class App extends Component {
  handlePersistorState = () => {
    const { persistor } = this.props;
    let { bootstrapped } = persistor.getState();
    if (bootstrapped) {
      if (this.props.onBeforeLift) {
        Promise.resolve(this.props.onBeforeLift())
          .then(() => this.setState({ bootstrapped: true }))
          .catch(() => this.setState({ bootstrapped: true }));
      } else {
        this.setState({ bootstrapped: true });
      }
    }
  };
  componentDidMount() {
    this.handlePersistorState();
    // let isLoggedIn = this.props.isLoggedIn;
  }
  render() {
    return (
      <Fragment>
        <Router history={history}>
          <ScrollToTop />
          <Switch>
            <Route path={path.HOME} exact component={Home} />
            <Route path={path.A5} exact component={ProductA5} />
            <Route path={path.CONTACT} exact component={Contact} />
            <Route path={path.ABOUT} exact component={About} />
            <Route path={path.FAQ} exact component={FAQ} />
            <Route path={path.PRIVACYPOLICY} exact component={PrivacyPolicy} />
            <Route path={path.REFUNDPOLICY} exact component={RefundPolicy} />
            <Route
              path={path.SHIPPINGPOLICY}
              exact
              component={ShippingPolicy}
            />
            <Route path={path.TERM} exact component={Term} />
            <Route path={path.FIBO} exact component={FIBO} />
            <Route path={path.ORDER} exact component={Order} />
            <Route
              path={path.PRODUCTWARRANTY}
              exact
              component={ProductWarranty}
            />
            <Route path={path.POST} exact component={Post} />
            {/* <Route path={path.TRIALPRODUCT} exact component={Trial} /> */}
          </Switch>

          <ConfirmModal />
          <ToastContainer
            className="toast-container"
            toastClassName="toast-item"
            bodyClassName="toast-item-body"
            autoClose={2000}
            hideProgressBar={true}
            pauseOnHover={false}
            pauseOnFocusLoss={true}
            closeOnClick={true}
            closeButton={<CustomToastCloseButton />}
          />
        </Router>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    started: state.app.started,
    isLoggedIn: state.user.isLoggedIn,
    userInfo: state.user.userInfo,
    access_token: state.user.access_token,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
